import { MouseEvent, useCallback, useRef, WheelEvent } from "react"
import { ScrollMenu, publicApiType } from "react-horizontal-scrolling-menu"

import useDrag from "../../hooks/useDrag"
import usePreventBodyScroll from "../../hooks/usePreventBodyScroll"
import TestimonialCard from "./TestimonialCard"
import { MemberTestimonials } from "./constants"

const PaywallTestimonialSlider = () => {
  const { dragStart, dragStop, dragMove } = useDrag()
  const { disableScroll, enableScroll } = usePreventBodyScroll()
  const scrollMenuRef = useRef<publicApiType>(null!)

  const handleDrag = useCallback(
    ({ scrollContainer }: publicApiType) =>
      (ev: MouseEvent) =>
        dragMove(ev, (posDiff: number) => {
          if (scrollContainer.current) {
            scrollContainer.current.scrollLeft += posDiff
          }
        }),
    [dragMove]
  )

  const handleMouseLeave = useCallback(() => {
    enableScroll()
    dragStop()
  }, [enableScroll, dragStop])

  const disableOnWheel = (_apiObj: publicApiType, ev: WheelEvent<Element>) => {
    ev.stopPropagation()
  }

  return (
    <div
      className="paywall-testimonial-slider bg-charcoal-600 pt-8 lg:pt-[46px] pb-[42px] lg:pb-[70px]"
      data-testid="paywall-testimonial-slider"
    >
      <h2
        className="text-white text-2xl text-center font-display font-semibold mb-[42px] lg:mb-15 px-4"
        data-testid="paywall-testimonial-slider-heading"
      >
        What NCX Members are saying
      </h2>

      <div onMouseEnter={disableScroll} onMouseLeave={handleMouseLeave}>
        <ScrollMenu
          apiRef={scrollMenuRef}
          onMouseDown={() => dragStart}
          onMouseUp={() => dragStop}
          onMouseMove={handleDrag}
          onWheel={disableOnWheel}
        >
          {MemberTestimonials.map((testimonial, index) => (
            <TestimonialCard
              key={index}
              name={testimonial.name}
              location={testimonial.location}
              acreage={testimonial.acreage}
              goal={testimonial.goal}
              quote={testimonial.quote}
              imageSrc={testimonial.imageSrc}
            />
          ))}
        </ScrollMenu>
      </div>
    </div>
  )
}

export default PaywallTestimonialSlider
